import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'VM',
  quote: 'Semana 2 con dolor 9/10. En 48 horas bajé a 3. El protocolo de agarre cambió todo.',
  name: 'Valentina M.',
  city: 'Buenos Aires'
}, {
  initials: 'CS',
  quote: 'El tracker me mostró 8 pañales húmedos. Gracias a eso no suplementé.',
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  initials: 'LR',
  quote: 'El Tomo 4 me explicó los brotes mejor que todo Google junto.',
  name: 'Luciana R.',
  city: 'Rosario'
}];
export function SocialProof() {
  return <section className="py-12 bg-brand-darker border-y border-brand-primary/10" data-id="element-255">
      <div className="max-w-6xl mx-auto px-4" data-id="element-256">
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-12 text-center" data-id="element-257">
          <div className="flex flex-col" data-id="element-258">
            <span className="text-3xl md:text-4xl font-serif text-brand-cream-light" data-id="element-259">
              +1.200
            </span>
            <span className="text-brand-primary text-sm uppercase tracking-wider mt-1" data-id="element-260">
              mamás
            </span>
          </div>
          <div className="flex flex-col" data-id="element-261">
            <span className="text-3xl md:text-4xl font-serif text-brand-cream-light" data-id="element-262">
              6
            </span>
            <span className="text-brand-primary text-sm uppercase tracking-wider mt-1" data-id="element-263">
              Tomos
            </span>
          </div>
          <div className="flex flex-col" data-id="element-264">
            <span className="text-3xl md:text-4xl font-serif text-brand-cream-light" data-id="element-265">
              6
            </span>
            <span className="text-brand-primary text-sm uppercase tracking-wider mt-1" data-id="element-266">
              Bonos
            </span>
          </div>
          <div className="flex flex-col" data-id="element-267">
            <span className="text-3xl md:text-4xl font-serif text-brand-cream-light flex items-center justify-center gap-2" data-id="element-268">
              4.9/5 <Star className="fill-brand-gold text-brand-gold w-6 h-6" data-id="element-269" />
            </span>
            <span className="text-brand-primary text-sm uppercase tracking-wider mt-1" data-id="element-270">
              Calificación
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-271">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark p-6 rounded-2xl border border-brand-primary/20 shadow-lg" data-id="element-272">
              <div className="flex items-center gap-4 mb-4" data-id="element-273">
                <div className="w-12 h-12 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-accent font-bold text-lg" data-id="element-274">
                  {t.initials}
                </div>
                <div className="flex gap-1" data-id="element-275">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-276" />)}
                </div>
              </div>
              <p className="text-brand-cream text-lg italic mb-4" data-id="element-277">
                "{t.quote}"
              </p>
              <div className="text-sm text-brand-primary" data-id="element-278">
                <span className="font-bold text-brand-cream-light" data-id="element-279">
                  — {t.name}
                </span>
                , {t.city}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}